import { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { IMenu } from '../../../models/menus.model';
import Button from '../../Button';
import { Descriptions } from 'antd';
import useAuth from '../../../hooks/useAuth';
import Radio from '../../Radio';

interface IProps {
  menu: IMenu | null;
  onSubmit: Function;
  cancelPath: string | null;
}

const SystemMenuEditor: FC<IProps> = ({ menu, onSubmit, cancelPath }) => {
  const { writeAuthYn } = useAuth();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const [korName, setKorName] = useState('');
  const [engName, setEngName] = useState('');
  const [menuUrl, setMenuUrl] = useState('');
  const [iconName, setIconName] = useState('');
  const [useYn, setUseYn] = useState('Y');

  const korNameInput = useRef<any>();
  const engNameInput = useRef<any>();
  const menuUrlInput = useRef<any>();

  useEffect(() => {
    if (menu) {
      setKorName(menu.korName);
      setEngName(menu.engName);
      setMenuUrl(menu.menuUrl);
      setIconName(menu.iconName);
      setUseYn(menu.useYn);
    }
  }, [menu])

  const onSave = async () => {
    if (!korName) {
      korNameInput.current.focus();
      return enqueueSnackbar(t('system.menu.message1'));
    }
    if (!engName) {
      engNameInput.current.focus();
      return enqueueSnackbar(t('system.menu.message2'));
    }
    if (!menuUrl) {
      menuUrlInput.current.focus();
      return enqueueSnackbar(t('system.menu.message3'));
    }
    if (!useYn) {
      return enqueueSnackbar(t('student.student.92'));
    }

    onSubmit({
      korName,
      engName,
      menuUrl,
      iconName,
      useYn
    })
  }

  return (
    <div className="comm-table__area rowType edit mt-1">
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item label={t('system.menu.column2')}>
          <input
            type="text"
            className="form-control input-text"
            value={korName}
            onChange={e => setKorName(e.target.value)}
            ref={korNameInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={t('system.menu.column3')}>
          <input
            type="text"
            className="form-control input-text"
            value={engName}
            onChange={e => setEngName(e.target.value)}
            ref={engNameInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={t('system.menu.column5')}>
          <input
            type="text"
            className="form-control input-text"
            value={menuUrl}
            onChange={e => setMenuUrl(e.target.value)}
            ref={menuUrlInput}
          />            
        </Descriptions.Item>
        <Descriptions.Item label={t('system.menu.column6')}>
          <input
            type="text"
            className="form-control input-text"
            value={iconName}
            onChange={e => setIconName(e.target.value)}
          />            
        </Descriptions.Item>
        <Descriptions.Item label={t('student.student.93')}>
          <Radio
            checked={useYn === 'Y'}
            onChange={() => setUseYn('Y')}
            text={t('common.option.yes')}
          />
          <Radio
            className="ml-4"
            checked={useYn === 'N'}
            onChange={() => setUseYn('N')}
            text={t('common.option.no')}
          />
        </Descriptions.Item>
      </Descriptions>

      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            onClick={onSave}
            className="btn-basic pink"
            text={t('common.button.save')}
            writeAuthYn={writeAuthYn}
          />
          <Button
            onClick={() => history.push(cancelPath ? cancelPath : '/system/menu')}
            className="btn-basic gray"
            text={t('common.button.cancel')}
          />
        </div>
      </div>
    </div>    
  )
}

export default SystemMenuEditor;
